/**
 * Merges multiple refs into a single callback ref.
 *
 * @param refs Refs that should all receive the same instance.
 * @returns A callback ref that updates every provided ref.
 *
 * @example
 * const Foo = ({ref}: {ref?: React.Ref<HTMLDivElement>}) => {
 *     const localRef = React.useRef<HTMLDivElement | null>(null);
 *
 *     return <div ref={mergeRefs(localRef, ref)} />;
 * };
 */
export const mergeRefs = (...refs) => {
    return (value) => {
        refs.forEach(ref => {
            if (typeof ref === 'function') {
                ref(value);
            }
            else if (ref !== null) {
                // `LegacyRef` widens to `string | RefObject` whose `current` is read-only in the
                // types, but React mutates it at runtime — cast to the mutable shape to assign it.
                ref.current = value;
            }
        });
    };
};
